// extracted by mini-css-extract-plugin
module.exports = {"BooleanListFeature":"wi_a bhs_b"};